module.exports = __webpack_public_path__ + "static/media/34.0d6cb2ac.png";